// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope } from "~/hooks/useScope";
import { GET_SERVICE_ACCOUNT } from "./action";

export function canGetServiceAccount(scope: Scope): boolean {
  return scope.iamActions.includes(GET_SERVICE_ACCOUNT);
}
